import React, { useEffect, useState } from 'react';
import MetaTags from 'react-meta-tags';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Container, Label, Row,
} from "reactstrap";
import { IsCBMManagment, IsSweetAndSnacksCompany, amountCommaSeparateFunc, breadcrumbReturnFunc, currentDate_ymd, date_ymd_func, loginIsSCMCompany, loginPartyID, loginSelectedPartyID, loginUserIsFranchisesRole } from '../../../components/Common/CommonFunction';
import * as url from "../../../routes/route_url";
import * as pageId from "../../../routes/allPageID"
import { challanList_ForListPage, commonPageField, commonPageFieldSuccess, getGRNListPage } from '../../../store/actions';
import * as mode from "../../../routes/PageMode"
import { clearDashboard, getDashbordDetails, getDashbordDetails_Success } from '../../../store/Dashboard/Dashboard_1_Redux/action';
import PaymentEntryList from './PaymentEntryList';
import InvoiceForGRN from './GRNList';
import SalesReturnListForDashboard from './SalesReturnListForDashboard';
import { DashboardLoader, PageLoadingSpinner } from '../../../components/Common/CommonButton';
import MobileRetailerApprove from './MobileRetailerApprove';
import DemandListForDashboard from './demand';
import WorkOrderForDashboard from './WorkOrder';

import Pie from '../FrenchiesesDashboard/pie';
import { ERP_LINK } from '../../../helpers/_serverPath';
import { formatDate, GetDailySaleData } from '../FrenchiesesDashboard/Function';

import { C_DatePicker } from '../../../CustomValidateForm';
import PosExeVersionDetails from '../FrenchiesesDashboard/PosExeVersionDetails';
import { getMaterialIssueListPage } from '../../../store/Production/Matrial_Issue/action';
import { getWorkOrderListPage } from '../../../store/Production/WorkOrder/action';

const Dashboard_1 = (props) => {

    const history = useHistory()
    const dispatch = useDispatch();
    const IsCompanySweetAndSnacks = IsSweetAndSnacksCompany()
    const [userPageAccessState, setUserAccState] = useState('');
    const [selectedOption, setSelectedOption] = useState('TODAYS');
    const [data, setData] = useState([]);
    const [amountLoading, setAmountLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);




    const isFrenchises = loginUserIsFranchisesRole()
    const IsMannagementParty = IsCBMManagment();

    const getTodayRange = () => ({
        fromDate: date_ymd_func(),
        toDate: date_ymd_func(),
    });

    const [dateRange, setDateRange] = useState(getTodayRange);

    //Access redux store Data /  'save_ModuleSuccess' action data
    const {
        getDashboard,
        userAccess,
        workOrderList,
        GRNListLoading,
        pageField,
        SalesReturnListloading,
        PaymentEntryListloading,
        commonPartyDropSelect,
        materialIssueList,
        challanList } = useSelector((state) => ({
            getDashboard: state.DashboardReducer.getDashboard,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageField,
            orderApprovalMsg: state.OrderReducer.orderApprovalMsg,
            GRNListLoading: state.OrderReducer.goBtnLoading,
            SalesReturnListloading: state.SalesReturnReducer.loading,
            PaymentEntryListloading: state.ReceiptReducer.loading,
            commonPartyDropSelect: state.CommonPartyDropdownReducer.commonPartyDropSelect,
            workOrderList: state.WorkOrderReducer.WorkOrderList,
            materialIssueList: state.MaterialIssueReducer.materialIssueList,
            challanList: state.ChallanReducer.ChallanList
        }));

    const { OrderCount, InvoiceCount, GRNsCount, MobileAppOrderCount } = getDashboard

    useEffect(() => {
        const page_Id = pageId.DASHBORD_1//changes
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id))


    }, []);

    useEffect(() => {
        const partyId = commonPartyDropSelect?.value;

        if (!partyId || partyId <= 0) {
            dispatch(clearDashboard());
            return;
        }

        dispatch(
            getDashbordDetails({
                loginPartyID: partyId,
            })
        );
    }, [commonPartyDropSelect?.value, dispatch]);
    const [hoveredIdx, setHoveredIdx] = useState(null);
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)//changes
    const pendingWO = workOrderList.filter(
        i => i.RemainingLot > 0 || i.RemaningQty > 0
    ).length;

    const pendingMI = materialIssueList.filter(
        i => i.Status !== 2 && Number(i.Percentage) < 100
    ).length;

    const pendingGRNQty = challanList?.filter(
        item => Number(item.inward) === 0
    ).length || 0;




    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;

        if (hasShowModal) {
            locationPath = props.masterPath;
        };

        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })

        if (userAcc) {
            setUserAccState(userAcc)
            breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    useEffect(() => {
        const refreshDashboardDate = () => {
            if (document.visibilityState === "hidden") return;

            if (selectedOption !== "TODAYS") return;

            const today = date_ymd_func();

            setDateRange((prev) => {
                if (
                    prev.fromDate === today &&
                    prev.toDate === today
                ) {
                    return prev;
                }

                return {
                    fromDate: today,
                    toDate: today,
                };
            });
        };

        window.addEventListener("focus", refreshDashboardDate);

        document.addEventListener(
            "visibilitychange",
            refreshDashboardDate
        );

        const interval = setInterval(refreshDashboardDate, 60000);

        return () => {
            window.removeEventListener("focus", refreshDashboardDate);

            document.removeEventListener(
                "visibilitychange",
                refreshDashboardDate
            );

            clearInterval(interval);
        };
    }, [selectedOption]);




    function paymentEntry_onClick() {
        history.push(url.PAYMENT_ENTRY_LIST)
    }

    function InvoiceFoRGRN_onClick() {
        if (IsCompanySweetAndSnacks) {
            history.push(url.IB_GRN_LIST)
        } else {
            history.push(url.GRN_STP_3)
        }
    }

    function salesReturn_onClick() {
        history.push(url.SALES_RETURN_LIST)
    }

    function mobileRetailerAprproveLinkHandler() {
        history.push(url.RETAILER_APPROVAL)
    }

    function demandListLinkHandler() {
        history.push(url.IB_ORDER_SO_LIST)
    }

    const handleChange = (event) => {
        const value = event.target.value;
        setSelectedOption(value);
        setAmountLoading(true);  // Spinner start

        const today = new Date();
        let fromDate;
        let toDate;

        if (value === 'TODAYS') {
            fromDate = toDate = formatDate(today);
        } else if (value === 'YESTERDAY') {
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            fromDate = toDate = formatDate(yesterday);
        } else if (value === 'MONTH') {
            const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            fromDate = formatDate(firstDayOfMonth);
            toDate = formatDate(today);
        } else if (value === 'SIX_MONTH') {
            const sixMonthsAgo = new Date(today);
            sixMonthsAgo.setMonth(today.getMonth() - 6);
            fromDate = formatDate(sixMonthsAgo);
            toDate = formatDate(today);
        } else if (value === 'CUSTOM') {
            fromDate = dateRange.fromDate;
            toDate = dateRange.toDate;
        }

        setDateRange({ fromDate, toDate });
    };




    const RedirectHandler = (Type) => {
        if (Type === 1) {
            history.push(url.ORDER_LIST_4)

        } else if (Type === 2) {
            (isFrenchises || IsMannagementParty) ? history.push(url.POS_INVOICE_LIST) : history.push(url.INVOICE_LIST_1)
        }
        else if (Type === 3) {
            history.push(url.APP_ORDER_LIST)
        } else {
            history.push(url.GRN_LIST_3)
        }
    }

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            setLoadingData(true); // start loading
            try {
                const jsonData = await GetDailySaleData({
                    fromDate: dateRange.fromDate,
                    toDate: dateRange.toDate,
                    Party_Id: commonPartyDropSelect.value,
                });

                if (isMounted && jsonData?.Data) {
                    setData(jsonData.Data);
                }
            } catch (error) {
                console.error("Error fetching dashboard data", error);
            }
            setAmountLoading(false);
            if (isMounted) setLoadingData(false); // done loading
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [dateRange]);

    useEffect(() => {
        if (!IsCompanySweetAndSnacks) return;
        if (!commonPartyDropSelect || commonPartyDropSelect.value <= 0) return;

        const today = date_ymd_func();
        const partyId = loginSelectedPartyID();

        // 1️⃣ Work Order List (JSON STRING REQUIRED)
        dispatch(
            getWorkOrderListPage({
                jsonBody: JSON.stringify({
                    FromDate: today,
                    ToDate: today,
                    Party: partyId,
                }),
                subPageMode: url.WORK_ORDER_LIST,
            })
        );

        // 2️⃣ Material Issue List (PLAIN OBJECT ONLY ❗)
        dispatch(
            getMaterialIssueListPage({
                FromDate: today,
                ToDate: today,
                Party: partyId,
            })
        );
    }, [IsCompanySweetAndSnacks, commonPartyDropSelect]);

    const encodeId = (id) => {
        return btoa(id.toString()); // Converts ID to Base64 encoded string
    };

    const hasPageAccess = (actualPagePath) => {
        return userAccess.some(
            page => page.ActualPagePath === actualPagePath
        );
    };

    const renderKPICard = (item, idx, { showAccent = false } = {}) => {
        const isActive = item.value > 0 || item.alwaysActive;
        const isHovered = hoveredIdx === idx && isActive && item.hasAccess;

        return (
            <div
                onMouseEnter={() => isActive && setHoveredIdx(idx)}
                onMouseLeave={() => setHoveredIdx(null)}
                onClick={isActive && item.hasAccess ? item.onClick : undefined}
                style={{
                    cursor: item.hasAccess ? "pointer" : "not-allowed",
                    background: "#ffffff",
                    border: "1px solid #eaeaea",
                    borderLeft: !showAccent ? `4px solid ${item.color}` : undefined,
                    borderRadius: "8px",
                    padding: "12px 14px",
                    height: "72px",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    // opacity: item.hasAccess ? 1 : 0.55,

                    /* 🔥 SAME hover effect */
                    transform: isHovered ? "translateY(-2px)" : "translateY(0)",
                    boxShadow: isHovered
                        ? "0 6px 14px rgba(0,0,0,0.08)"
                        : "none",
                    transition: "all 0.18s ease-in-out",
                }}
            >
                {/* Optional top accent (Pending KPI style) */}
                {showAccent && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: isHovered ? "56px" : "40px",
                            height: "4px",
                            background: item.color,
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                            transition: "width 0.18s ease-in-out",
                        }}
                    />
                )}

                <div
                    style={{
                        fontSize: "12px",
                        color: "#6c757d",
                        marginBottom: "2px",
                        fontWeight: 600,
                    }}
                >
                    {item.title}
                </div>

                <div
                    style={{
                        fontSize: "22px",
                        fontWeight: 600,
                        color: isActive ? "#212529" : "#ced4da",
                        lineHeight: "1.2",
                    }}
                >
                    {item.value}
                </div>
            </div>
        );
    };

    const topKPIs = [
        {
            title: "Total Orders",
            value: OrderCount,
            hasAccess: hasPageAccess("OrderList_4"),
            onClick: () => RedirectHandler(1),
            color: "#4e73df",
            alwaysActive: true,
        },
        !IsCompanySweetAndSnacks && {
            title: "Mobile App Orders",
            value: MobileAppOrderCount,
            hasAccess: hasPageAccess("App_Order_List"),
            onClick: () => RedirectHandler(3),
            color: "#1cc88a",
            alwaysActive: true,
        },
        {
            title: "Total Invoices",
            value: InvoiceCount,
            hasAccess: (isFrenchises || IsMannagementParty) ? hasPageAccess("Pos_InvoiceList") : hasPageAccess("InvoiceList_1"),
            onClick: () => RedirectHandler(2),
            color: "#36b9cc",
            alwaysActive: true,
        },
        {
            title: "Total GRNs",
            value: GRNsCount,
            hasAccess: hasPageAccess("GRN_LIST_3"),
            onClick: () => RedirectHandler(),
            color: "#f6c23e",
            alwaysActive: true,
        },
    ].filter(Boolean);

    const pendingKPIs = [
        {
            title: "Pending GRN",
            value: pendingGRNQty,
            color: "#8fb9a8",
            hasAccess: hasPageAccess("IB_INVOICE_FOR_GRN"),
            onClick: () => history.push(url.IB_INVOICE_FOR_GRN),
            alwaysActive: true,
        },
        {
            title: "Pending Work Order",
            value: pendingWO,
            color: "#9aa7bd",
            hasAccess: hasPageAccess("MaterialIssue_STP"),
            onClick: () => history.push(url.MATERIAL_ISSUE_STP),
            alwaysActive: true,
        },
        {
            title: "Pending Material Issue",
            value: pendingMI,
            color: "#c49a9a",
            hasAccess: hasPageAccess("Production_STP"),
            onClick: () => history.push(url.PRODUCTION_STP),
            alwaysActive: true,
        },

    ];



    return (
        <React.Fragment>
            <PageLoadingSpinner isLoading={GRNListLoading || PaymentEntryListloading || SalesReturnListloading || !pageField} />
            <div className="page-content" style={{
                backgroundColor: "#f4f6fb",
                minHeight: "100vh",
                paddingBottom: "20px",
            }}>
                <MetaTags>
                    <title>Dashboard | FoodERP 2.0 - React Admin & Dashboard Template</title>
                </MetaTags>
                <Container fluid>

                    <Row style={{ marginBottom: "12px" }}>
                        {topKPIs.map((item, idx) => (
                            <Col xl={3} md={3} key={idx}>
                                {renderKPICard(
                                    { ...item, alwaysActive: true },
                                    idx
                                )}
                            </Col>
                        ))}
                    </Row>


                    {IsCompanySweetAndSnacks && (
                        <>
                            {/* 🔹 Pending Records Heading */}
                            <Row style={{ marginBottom: "6px" }}>
                                <Col>
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 700,
                                            color: "#495057",
                                            letterSpacing: "0.3px",
                                        }}
                                    >
                                        Pending Records
                                    </div>
                                </Col>
                            </Row>

                            {/* 🔹 Pending KPI Cards */}
                            <Row style={{ marginBottom: "14px" }}>
                                {pendingKPIs.map((item, idx) => (
                                    <Col xl={4} md={4} key={idx}>
                                        {renderKPICard(
                                            item,          // already has alwaysActive: true
                                            idx + 100,
                                            { showAccent: true }
                                        )}
                                    </Col>
                                ))}
                            </Row>
                        </>
                    )}

                    <Row>
                        {(!IsCompanySweetAndSnacks) && (!loginUserIsFranchisesRole()) && <Col lg={6}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                            }}>
                                <CardHeader style={{
                                    backgroundColor: "transparent",
                                    borderBottom: "1px solid #eef0f4",
                                    padding: "12px 16px",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#343a40",
                                }}
                                    className="d-flex align-items-center" >

                                    <Label
                                        onClick={paymentEntry_onClick}
                                        disabled={PaymentEntryListloading}
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#4e73df",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Today's Payment Entry</Label>&nbsp;&nbsp;&nbsp;
                                    {(PaymentEntryListloading) &&
                                        <DashboardLoader />
                                    }
                                </CardHeader>
                                <PaymentEntryList />
                            </Card>
                        </Col>}


                        {isFrenchises && (
                            <Col lg={6}>
                                <Card style={{
                                    borderRadius: "14px",
                                    border: "none",
                                    backgroundColor: "#ffffff",
                                    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                    marginBottom: "16px",
                                }}>
                                    <CardHeader
                                        className="d-flex align-items-center"
                                        style={{
                                            backgroundColor: "transparent",
                                            borderBottom: "1px solid #eef0f4",
                                            padding: "12px 16px",
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#343a40",
                                        }}
                                    >
                                        {/* LEFT TITLE */}

                                        <div>
                                            <Label
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 600,
                                                    color: "#343a40",
                                                }}
                                            >
                                                Daily Top 5 Selling Items
                                            </Label>
                                        </div>
                                        {/* RIGHT ACTION LINK */}
                                        <Label
                                            style={{
                                                marginLeft: "auto",            // 🔥 KEY LINE
                                                fontSize: "13px",
                                                fontWeight: 600,
                                                color: "#4e73df",
                                                cursor: "pointer",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                padding: "6px 10px",
                                                borderRadius: "8px",
                                                backgroundColor: "rgba(78,115,223,0.08)",
                                                marginTop: "7px"
                                            }}
                                            onMouseEnter={e =>
                                                (e.currentTarget.style.backgroundColor = "rgba(78,115,223,0.14)")
                                            }
                                            onMouseLeave={e =>
                                                (e.currentTarget.style.backgroundColor = "rgba(78,115,223,0.08)")
                                            }
                                        >
                                            <a
                                                href={`${ERP_LINK}${url.DAILY_SALE_REPORT}/${encodeId(loginPartyID())}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: "inherit",
                                                    textDecoration: "none",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                View Daily Sales Report ↗
                                            </a>
                                        </Label>
                                        <div>
                                            {(data[0]?.TopSaleItems?.length === undefined) || (data[0]?.TopSaleItems?.length === 0) ? null :
                                                <div className="d-flex flex-wrap align-items-center mb-n2 mt-1 ">
                                                    <div style={{ marginLeft: "55px" }}>
                                                        <select className="form-select form-select-sm"
                                                            style={{
                                                                borderRadius: "10px",
                                                                fontSize: "11px",
                                                                padding: "6px 30px 6px 14px", //  RIGHT padding increased
                                                                backgroundColor: "#fff",
                                                                border: "1px solid #dee2e6",
                                                            }}
                                                            value={selectedOption} onChange={handleChange}>
                                                            <option value="TODAYS">Today's</option>
                                                            <option value="YESTERDAY">Yesterday</option>
                                                            <option value="MONTH">Month</option>
                                                            <option value="SIX_MONTH">Six Month</option>

                                                        </select>

                                                        {selectedOption === "CUSTOM" && (
                                                            <div style={{ marginTop: "10px", backgroundColor: "#whitesmoke" }}>


                                                                <C_DatePicker
                                                                    options={{
                                                                        altInput: true,
                                                                        altFormat: "d-m-Y",
                                                                        dateFormat: "Y-m-d",
                                                                        minDate: "today",
                                                                    }}
                                                                    name="FromDate"
                                                                    value={dateRange.fromDate}
                                                                    onChange={(e, date) => {
                                                                        setDateRange((i) => {
                                                                            const a = { ...i }
                                                                            a.fromDate = date;
                                                                            return a
                                                                        })
                                                                    }}
                                                                />

                                                                <C_DatePicker
                                                                    options={{
                                                                        altInput: true,
                                                                        altFormat: "d-m-Y",
                                                                        dateFormat: "Y-m-d",
                                                                        minDate: "today",
                                                                    }}
                                                                    name="ToDate"
                                                                    value={dateRange.toDate}
                                                                    onChange={(e, date) => {
                                                                        setDateRange((i) => {
                                                                            const a = { ...i }
                                                                            a.toDate = date;
                                                                            return a
                                                                        })
                                                                    }}
                                                                />

                                                            </div>
                                                        )}
                                                    </div>


                                                    <div className="ml-auto" style={{ marginLeft: "5px" }}>
                                                        {amountLoading ? (
                                                            <span className="badge rounded-pill badge-soft-primary fw-large d-flex align-items-center justify-content-center" style={{ fontSize: "20px" }}>
                                                                <div className="spinner-border spinner-border-sm text-primary"></div>  {/*  Spinner */}
                                                            </span>
                                                        ) : (
                                                            <span className="badge rounded-pill badge-soft-primary fw-large" style={{ fontSize: "20px" }}>
                                                                ₹ {data[0]?.TotalAmount ? amountCommaSeparateFunc(data[0].TotalAmount) : 0}
                                                            </span>
                                                        )}
                                                    </div>

                                                </div>}
                                        </div>


                                    </CardHeader>

                                    <CardBody style={{
                                        padding: "12px 16px",
                                    }}>



                                        {!loadingData && data[0]?.TopSaleItems?.length > 0 && (
                                            <Pie
                                                Item={data[0].TopSaleItems}
                                                key={`${dateRange.fromDate}_${dateRange.toDate}`}
                                            />
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        )}

                        {IsCompanySweetAndSnacks &&
                            <Col lg={12}>
                                <Card style={{
                                    borderRadius: "14px",
                                    border: "none",
                                    backgroundColor: "#ffffff",
                                    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                    marginBottom: "16px",
                                }}>
                                    <CardHeader style={{
                                        backgroundColor: "transparent",
                                        borderBottom: "1px solid #eef0f4",
                                        padding: "12px 16px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#343a40",
                                    }}
                                        className="d-flex align-items-center">
                                        <Label
                                            onClick={demandListLinkHandler}
                                            disabled={false}
                                            style={{
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#4e73df",
                                                cursor: "pointer",
                                            }}

                                        >
                                            IB Sales Order List</Label>
                                        {(SalesReturnListloading) &&
                                            <DashboardLoader />
                                        }
                                    </CardHeader>
                                    <DemandListForDashboard />
                                </Card>
                            </Col>
                        }

                        {<Col lg={IsCompanySweetAndSnacks ? 12 : 6}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                            }}>
                                <CardHeader style={{
                                    backgroundColor: "transparent",
                                    borderBottom: "1px solid #eef0f4",
                                    padding: "12px 16px",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#343a40",
                                }}
                                    className="d-flex align-items-center">
                                    <Label

                                        disabled={GRNListLoading}
                                        onClick={InvoiceFoRGRN_onClick}
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#4e73df",
                                            cursor: "pointer",
                                        }}

                                    >
                                        Invoices For GRN</Label>
                                    {(GRNListLoading) &&
                                        <DashboardLoader />
                                    }
                                </CardHeader>
                                <InvoiceForGRN />

                            </Card>
                        </Col>}

                    </Row>
                    {/* <Row>
                        {(IsMannagementParty) && <Col lg={12}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                            }}>

                                <PosExeVersionDetails />

                            </Card>
                        </Col>}
                    </Row> */}

                    <Row>
                        <Col lg={IsCompanySweetAndSnacks ? 12 : 6}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                            }}>
                                <CardHeader style={{
                                    backgroundColor: "transparent",
                                    borderBottom: "1px solid #eef0f4",
                                    padding: "12px 16px",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#343a40",
                                }}
                                    className="d-flex align-items-center">
                                    <Label
                                        onClick={salesReturn_onClick}
                                        disabled={SalesReturnListloading}
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            color: "#4e73df",
                                            cursor: "pointer",
                                        }}

                                    >
                                        Sales Return List</Label>
                                    {(SalesReturnListloading) &&
                                        <DashboardLoader />
                                    }
                                </CardHeader>
                                <SalesReturnListForDashboard />
                            </Card>
                        </Col>

                        {!IsCompanySweetAndSnacks && <Col lg={6}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                            }}>
                                <div className='mb-n6'>
                                    <CardHeader style={{
                                        backgroundColor: "transparent",
                                        borderBottom: "1px solid #eef0f4",
                                        padding: "12px 16px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#343a40",
                                    }}
                                        className="d-flex align-items-center">
                                        <Label
                                            onClick={mobileRetailerAprproveLinkHandler}
                                            disabled={SalesReturnListloading}
                                            style={{
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#4e73df",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Mobile Retailer Approve</Label>
                                        {(SalesReturnListloading) &&
                                            <DashboardLoader />
                                        }
                                    </CardHeader>
                                </div>
                                <MobileRetailerApprove />
                            </Card>
                        </Col>}

                        {false && <Col lg={6}>
                            <Card style={{
                                borderRadius: "14px",
                                border: "none",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                marginBottom: "16px",
                            }}>
                                <div className='mb-n6'>
                                    <CardHeader style={{
                                        backgroundColor: "transparent",
                                        borderBottom: "1px solid #eef0f4",
                                        padding: "12px 16px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#343a40",
                                    }}
                                        className="d-flex align-items-center">
                                        <Label
                                            onClick={mobileRetailerAprproveLinkHandler}
                                            disabled={SalesReturnListloading}
                                            style={{
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                color: "#4e73df",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Item Wise Work Order</Label>
                                        {(SalesReturnListloading) &&
                                            <DashboardLoader />
                                        }
                                    </CardHeader>
                                </div>
                                <WorkOrderForDashboard />
                            </Card>
                        </Col>}
                    </Row>
                    {(!loginIsSCMCompany() && !IsSweetAndSnacksCompany()) && (
                        <Col lg={12}>
                            <Card
                                style={{
                                    borderRadius: "14px",
                                    border: "none",
                                    backgroundColor: "#ffffff",
                                    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                                    marginBottom: "16px",
                                }}
                            >
                                <PosExeVersionDetails />
                            </Card>
                        </Col>
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
}

export default Dashboard_1;